package one.healthium.log_water.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag
import androidx.lifecycle.Lifecycle
import androidx.lifecycle.compose.LifecycleEventEffect
import one.healthium.log_water.ui.internal.LogWaterControl
import one.healthium.log_water.ui.internal.LogWaterViewModel
import org.koin.compose.viewmodel.koinViewModel

interface LogWaterEventDelegate {
    fun onCloseClicked()
}

@Composable
fun LogWaterScreen(
    taskId: String?,
    eventDelegate: LogWaterEventDelegate
) {
    val viewModel = koinViewModel<LogWaterViewModel>()
    val state by viewModel.state.collectAsState()

    SaveEffect {
        viewModel.onWaterIntakeEditFinished(taskId)
    }

    val waterIntake = state.waterIntake
    if (waterIntake != null) {
        LogWaterControl(
            modifier = Modifier.testTag("log_water_screen"),
            value = waterIntake,
            isMetric = state.isMetric,
            onIncreaseClicked = viewModel::onIncreaseWaterIntake,
            onDecreaseClicked = viewModel::onDecreaseWaterIntake,
            onCloseClicked = {
                viewModel.onWaterIntakeEditFinished(taskId)
                eventDelegate.onCloseClicked()
            },
        )
    }
}

@Composable
private fun SaveEffect(
    onSaveEvent: () -> Unit,
) {
    LifecycleEventEffect(Lifecycle.Event.ON_PAUSE) {
        onSaveEvent()
    }
}
